import * as React from 'react'

import { Box, Button, List, Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

interface Props {
  label: string
  onDelete: () => void
  disabled?: boolean
  bordered?: boolean
}

const RoleSupervisorsListItem: React.FC<Props> = ({ label, onDelete, disabled, bordered }) => {
  const [open, toggle] = useToggle(false)
  const button = (
    <Button disabled={disabled} type="secondary" onClick={onDelete} iconName="delete" />
  )

  return (
    <Box
      border={
        bordered && {
          bottom: {
            width: 's1',
            style: 'solid',
            color: 'grey400',
          },
        }
      }
    >
      <List.Item>
        <Box width="full" paddingRight="s8" overflowY="hidden">
          <Text.Normal color="grey800" size="300" weight="medium" ellipsis>
            {label}
          </Text.Normal>
        </Box>
        {disabled ? (
          <Tooltip.Dialog
            attachment="bottom center"
            open={open}
            toggle={toggle}
            label={i18n.t('job_catalog.no_delete_supervisor')}
          >
            {button}
          </Tooltip.Dialog>
        ) : (
          button
        )}
      </List.Item>
    </Box>
  )
}

export default observer(RoleSupervisorsListItem)
